/**
 * Utilitários de classificação de erros de egress LiveKit.
 * Arquivo separado para evitar importação circular entre
 * recording-finalize-room.ts e recording-meet-api-sync.ts.
 */

/**
 * Erros que indicam o servidor LiveKit temporariamente indisponível/sobrecarregado.
 * O egress pod pode estar gravando normalmente — NÃO purgar o estado.
 */
export function isServerTemporarilyUnavailableError(error: unknown): boolean {
  const msg = (error instanceof Error ? error.message : String(error)).toLowerCase();
  return (
    msg.includes('no response from servers') ||
    msg.includes('unavailable') ||
    msg.includes('service unavailable')
  );
}

/**
 * Erros em que o egress realmente não existe mais no LiveKit — purge do Redis é seguro.
 * Não incluir erros de servidor temporariamente indisponível (ex: "no response from servers").
 */
export function isUnrecoverableStopEgressError(error: unknown): boolean {
  const msg = (error instanceof Error ? error.message : String(error)).toLowerCase();
  return (
    msg.includes('not found') ||
    msg.includes('does not exist') ||
    msg.includes('egress not found') ||
    msg.includes('unknown egress')
  );
}
